"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.covidVaccinationMessages = exports.hpvVaccinationMessages = exports.meningococcusVaccinationMessages = exports.havVaccinationMessages = exports.hbvVaccinationMessages = exports.pneumococusVaccinationMessages = exports.fluShotMessages = exports.CovidVaccination = exports.HpvVaccination = exports.MeningococcusVaccination = exports.HavVaccination = exports.HbvVaccination = exports.PneumococusVaccination = exports.FluShot = void 0;
const schema_1 = require("../../schema");
var FluShot;
(function (FluShot) {
    FluShot["YES"] = "YES";
    FluShot["NO"] = "NO";
})(FluShot || (exports.FluShot = FluShot = {}));
var PneumococusVaccination;
(function (PneumococusVaccination) {
    PneumococusVaccination["YES"] = "YES";
    PneumococusVaccination["NO"] = "NO";
})(PneumococusVaccination || (exports.PneumococusVaccination = PneumococusVaccination = {}));
var HbvVaccination;
(function (HbvVaccination) {
    HbvVaccination["YES"] = "YES";
    HbvVaccination["NO"] = "NO";
})(HbvVaccination || (exports.HbvVaccination = HbvVaccination = {}));
var HavVaccination;
(function (HavVaccination) {
    HavVaccination["YES"] = "YES";
    HavVaccination["NO"] = "NO";
})(HavVaccination || (exports.HavVaccination = HavVaccination = {}));
var MeningococcusVaccination;
(function (MeningococcusVaccination) {
    MeningococcusVaccination["YES"] = "YES";
    MeningococcusVaccination["NO"] = "NO";
})(MeningococcusVaccination || (exports.MeningococcusVaccination = MeningococcusVaccination = {}));
var HpvVaccination;
(function (HpvVaccination) {
    HpvVaccination["YES"] = "YES";
    HpvVaccination["NO"] = "NO";
})(HpvVaccination || (exports.HpvVaccination = HpvVaccination = {}));
var CovidVaccination;
(function (CovidVaccination) {
    CovidVaccination["YES"] = "YES";
    CovidVaccination["NO"] = "NO";
})(CovidVaccination || (exports.CovidVaccination = CovidVaccination = {}));
exports.fluShotMessages = {
    [FluShot.YES]: {
        id: "htx.vaccinationStatus.fluShot.YES",
        defaultMessage: "Igen"
    },
    [FluShot.NO]: {
        id: "htx.vaccinationStatus.fluShot.NO",
        defaultMessage: "Nem"
    }
};
exports.pneumococusVaccinationMessages = {
    [PneumococusVaccination.YES]: {
        id: "htx.vaccinationStatus.pneumococusVaccination.YES",
        defaultMessage: "Igen"
    },
    [PneumococusVaccination.NO]: {
        id: "htx.vaccinationStatus.pneumococusVaccination.NO",
        defaultMessage: "Nem"
    }
};
exports.hbvVaccinationMessages = {
    [HbvVaccination.YES]: {
        id: "htx.vaccinationStatus.hbvVaccination.YES",
        defaultMessage: "Igen"
    },
    [HbvVaccination.NO]: {
        id: "htx.vaccinationStatus.hbvVaccination.NO",
        defaultMessage: "Nem"
    }
};
exports.havVaccinationMessages = {
    [HavVaccination.YES]: {
        id: "htx.vaccinationStatus.havVaccination.YES",
        defaultMessage: "Igen"
    },
    [HavVaccination.NO]: {
        id: "htx.vaccinationStatus.havVaccination.NO",
        defaultMessage: "Nem"
    }
};
exports.meningococcusVaccinationMessages = {
    [MeningococcusVaccination.YES]: {
        id: "htx.vaccinationStatus.meningococcusVaccination.YES",
        defaultMessage: "Igen"
    },
    [MeningococcusVaccination.NO]: {
        id: "htx.vaccinationStatus.meningococcusVaccination.NO",
        defaultMessage: "Nem"
    }
};
exports.hpvVaccinationMessages = {
    [HpvVaccination.YES]: {
        id: "htx.vaccinationStatus.hpvVaccination.YES",
        defaultMessage: "Igen"
    },
    [HpvVaccination.NO]: {
        id: "htx.vaccinationStatus.hpvVaccination.NO",
        defaultMessage: "Nem"
    }
};
exports.covidVaccinationMessages = {
    [CovidVaccination.YES]: {
        id: "htx.vaccinationStatus.covidVaccination.YES",
        defaultMessage: "Igen"
    },
    [CovidVaccination.NO]: {
        id: "htx.vaccinationStatus.covidVaccination.NO",
        defaultMessage: "Nem"
    }
};
const fluShot = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(FluShot.YES),
    schema_1.Schema.singleChoiceItem(FluShot.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "flu_shot" })
    .tag({ vocab: "snomed", code: "73701000119109" })
    .tag({ vocab: "loinc", code: "72058-1" });
const pneumococusVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PneumococusVaccination.YES),
    schema_1.Schema.singleChoiceItem(PneumococusVaccination.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "pneumococus_vaccination" })
    .tag({ vocab: "snomed", code: "170337005" })
    .tag({ vocab: "loinc", code: "72057-3" });
const hbvVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbvVaccination.YES),
    schema_1.Schema.singleChoiceItem(HbvVaccination.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "hbv_vaccination" })
    .tag({ vocab: "snomed", code: "39031000119103" })
    .tag({ vocab: "loinc", code: "72056-5" });
const havVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HavVaccination.YES),
    schema_1.Schema.singleChoiceItem(HavVaccination.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "hav_vaccination" })
    .tag({ vocab: "snomed", code: "43941000119105" });
const meningococcusVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MeningococcusVaccination.YES),
    schema_1.Schema.singleChoiceItem(MeningococcusVaccination.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "meningococcus_vaccination" })
    .tag({ vocab: "snomed", code: "39361000119108" });
const hpvVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HpvVaccination.YES),
    schema_1.Schema.singleChoiceItem(HpvVaccination.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "hpv_vaccination" })
    .tag({ vocab: "snomed", code: "99501000119107" })
    .tag({ vocab: "loinc", code: "64663-8" });
const covidVaccination = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CovidVaccination.YES),
    schema_1.Schema.singleChoiceItem(CovidVaccination.NO)
])
    .interpretation({ vocab: "htx", code: "covid_vaccination" })
    .tag({ vocab: "snomed", code: "1142178009" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    fluShot,
    pneumococusVaccination,
    hbvVaccination,
    havVaccination,
    meningococcusVaccination,
    hpvVaccination,
    covidVaccination
})
    .tag({ vocab: "snomed", code: "408864009" })
    .tag({ vocab: "loinc", code: "82593-5" });
